import React, { useEffect, useState } from "react"
import {
  Card,
  CardBody,
  Col,
  Container,
  Row
} from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Draggable from "react-draggable"
import { ResizableBox } from "react-resizable"
//i18n
import { withTranslation } from "react-i18next"
import MyProjects from "./MyProjects"
import SupportIndex from "pages/Support/SupportIndex"
import configure from "configure"
import { data } from "autoprefixer"
import axios from "axios"
import secureLocalStorage from "react-secure-storage"


const Dashboard = props => {

  const [loading, setLaoding] = useState(false)
  const [projectData, setProjectData] = useState([])
  const [allProjectsData, setAllProjectsData] = useState("")
  const [inprogress_projects, setInprogressProjects] = useState([])

  const [projects_totalRevenue, setProjectsTotalRevenue] = useState("")
  const [projects_balance, setProjectsBalance] = useState("")
  const [helpVideo, setHelpVideo] = useState(false)

  useEffect(() => {
    fetchProjects()
  }, [])

  const fetchProjects = async () => {
    setLaoding(true)
    try {
      const authUser = secureLocalStorage.getItem("Token");
      const res = await axios({
        method: 'get',
        url: `${configure.apiUrl}/projects`,
        headers: {
          Authorization: `Bearer ${authUser}`,
        }
      }).then(res => {
        setProjectData(res.data.projects)
        setAllProjectsData(res.data.projects?.counts)

        if (res.data.data?.project2) {
          const inProgressProjects = res.data.data?.project2.filter(
            obj => obj.status == "In Progress"
          )
          setInprogressProjects(inProgressProjects || [])
        } else {
          setInprogressProjects(res.data.projects)
        }
        setLaoding(false)
      })
    } catch (error) {
      console.log("error", error)
      setLaoding(false)
    }

  }

  //meta title
  document.title = "Dashboards | Introducer Portal"
  const [reports, setReports] = useState(
    [
      { id: 1, title: "Total Projects", iconClass: "bx-copy-alt", description: inprogress_projects?.length },
      { id: 2, title: "Total Revenue", iconClass: "bx-archive-in", description: "₹ 0" },
      { id: 3, title: "Balance", iconClass: "bx-archive-in", description: "₹ 0" },
      {
        id: 4,
        title: "Received",
        iconClass: "bx-purchase-tag-alt",
        description: "₹ 0",
      },
    ]
  )

  const fetchData = async () => {
    try {
      setLaoding(true);

      const userData = secureLocalStorage.getItem("User");

      const [financeRes, invoiceRes, zithasRes] = await Promise.all([
        axios.get(`${configure.apiUrl}/finance/${userData.id}`),
        axios.get(`${configure.apiUrl}/introducerInvoice/${userData.id}`),
        axios.get(`${configure.apiUrl}/introducerZithasInvoice/${userData.id}`),
      ]);

      const financeData = financeRes?.data?.finances || [];

      // ✅ Combine both invoice arrays
      const ztplData = invoiceRes?.data?.data || [];
      const zithasData = zithasRes?.data?.data || [];
      const allInvoices = [...ztplData, ...zithasData];

      // ✅ Calculate total commission amount
      const totalCommissionCalc = allInvoices.reduce((sum, invoice) => {
        const items = invoice.items || [];
        const exchangeRate = Number(invoice.exchange_rate) || 1; // Default to 1 if not provided

        const invoiceCommission = items.reduce((itemSum, item) => {
          const commission = Number(item.commission_amount) || 1;
          return itemSum + commission * exchangeRate;
        }, 0);

        return sum + invoiceCommission;
      }, 0);

      // ✅ Calculate total received (paid) amount in INR
      const totalReceivedCalc = financeData.reduce((sum, item) => {
        const totalPaid = parseFloat(item.paid_amount) || 0;
        const exchangeRate = parseFloat(item.currency_rate) || 1;
        const amountInINR =
          item.currency_symbol === "₹" ? totalPaid : totalPaid * exchangeRate;
        return sum + amountInINR;
      }, 0);
      const diff = (Number(totalCommissionCalc) - Number(totalReceivedCalc))?.toLocaleString("en-IN")
      setReports(reports?.map((obj) => ({
        ...obj,
        description: obj?.id == 1 ? inprogress_projects?.length : obj?.id == 2 ? `₹ ${totalCommissionCalc?.toLocaleString("en-IN")}` : obj?.id == 3 ? `₹ ${diff}` : obj?.id == 4 ? `₹ ${totalReceivedCalc?.toLocaleString("en-IN")}` : '₹ 0'
      })))
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLaoding(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Dashboards")}
            breadcrumbItem={props.t("Dashboard")}
          />

          <Row>
            <Col xl="12">
              <Row>
                {/* Reports Render */}
                {reports.map((report, key) => (
                  <Col md="3" key={"_col_" + key}>
                    <Card className="mini-stats-wid custom_acctivity text-white" style={{
                      maxHeight: "150px",
                      background: key === 0 ? "rgb(123, 135, 234)" :
                        key === 1 ? "rgb(165, 158, 246)" :
                          key === 2 ? "rgb(148, 162, 240)" :
                            key === 3 ? "rgb(211, 150, 238)" : null
                    }}>
                      <CardBody>
                        <div className="d-flex ">
                          <div className="flex-grow-1">
                            <p className=" fw-medium">
                              {report.title}
                            </p>
                            <h5 className="mb-0">{report?.id == 1 ? inprogress_projects?.length : report?.description}</h5>
                          </div>
                          <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                            <span className="avatar-title rounded-circle bg-primary">
                              <i
                                className={
                                  "bx " + report.iconClass + " font-size-24"
                                }
                              ></i>
                            </span>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>

            <Col xl="12">
              <SupportIndex />
            </Col>

            {/* <Col xl="4">
                  {/* <WelcomeComponent />
                  <MyActivity/>
              </Col> */}

            <Col xl="12">
              <MyProjects inprogress_projects={inprogress_projects} />
            </Col>
          </Row>

          <div className={`note-sticky-form ${helpVideo ? "d-block" : "d-none"}`}>
            <Draggable handle=".modal-header" cancel=".modal-body">
              <ResizableBox
                width={900}
                style={{
                  position: "fixed",
                  top: "18%",
                  right: "15%",
                  zIndex: "999",
                  backgroundColor: "#fff",
                  maxHeight: "fit-content",
                  transform: "translate(-50%, -50%)",
                }}
              >
                <div className="modal-header ">
                  <h5 className="modal-title mt-0">Today&apos;s Punch Logs</h5>
                  <button
                    type="button"
                    onClick={() => {
                      setHelpVideo(false)
                    }}
                    className="btn-modal-close"
                  >
                    <span aria-hidden="true" className="btn-modal-span">
                      &times;
                    </span>
                  </button>
                </div>
                {/* <PunchLogs data={logs} /> */}
              </ResizableBox>
            </Draggable>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}


export default withTranslation()(Dashboard)
